import styled from '@emotion/styled'
import { Button as AntdButton, Spin as AntdSpin } from 'antd'
import Modal from '@/components/common/Modal'

export const Button = styled(AntdButton)``

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .ant-modal-header {
    border-bottom: none;

    .ant-modal-title {
      font-weight: 600;
      font-size: 16px;
      color: #333;
    }
  }

  .ant-modal-body {
    padding: 0px 0px 16px 0px;
  }

  .ant-modal-footer {
    border-top: none;
    background-color: #f8f9fa;
    padding: 16px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
`

export const ListWrapper = styled('div')`
  max-height: 280px;
  overflow: auto;
  border: 1px solid #ededed;
`

export const ListItem = styled('div')<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;

  &:not(:last-of-type) {
    border-bottom: 1px solid #f1f1f1;
  }
`

export const Name = styled('div')`
  color: #333;
  font-size: 14px;
`

export const EmptyState = styled('div')`
  padding: 24px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
`

export const Spin = styled(AntdSpin)`
  display: block;
  padding: 24px 0;
`
